// ConditionsTable.jsx
// Read-only table that displays a list of Kubernetes-style condition
// objects. Each condition typically contains: type, status, reason,
// message and last_transition_time. The component is intentionally
// small and stateless — it merely formats the provided data for
// compact display.
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import StatusPill from "./StatusPill";

/**
 * ConditionsTable
 * props:
 * - conditions: array of condition objects
 * - formatTimestamp: (ts: string) => string
 */
export default function ConditionsTable({ conditions = [], formatTimestamp }) {
  if (!conditions || conditions.length === 0) {
    return null;
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow
            sx={{
              "& th": {
                fontWeight: 600,
              },
            }}
          >
            <TableCell>Type</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Message</TableCell>
            <TableCell>Last Transition</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {conditions.map((cond, idx) => (
            <TableRow key={idx}>
              <TableCell>{cond.type}</TableCell>
              <TableCell>
                <StatusPill
                  label={cond.status}
                  color={cond.status === "True" ? "success" : "default"}
                />
              </TableCell>
              <TableCell>{cond.reason || "N/A"}</TableCell>
              <TableCell>{cond.message || "N/A"}</TableCell>
              <TableCell>
                {formatTimestamp
                  ? formatTimestamp(cond.last_transition_time)
                  : cond.last_transition_time}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ConditionsTable.propTypes = {
  conditions: PropTypes.arrayOf(PropTypes.object),
  formatTimestamp: PropTypes.func,
};
